export const CT_W = 2538
export const CAN_W = 1268
export const CAN_H = 720
export const MIN_H = 602
export const MAX_H = 720



/** WEBPACK FOOTER **
 ** ./src/constants/Constants.js
 **/